import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'STUDENT_CREDENTIALS_PATCH',
  PATCH_SUCCESS: 'STUDENT_CREDENTIALS_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_CREDENTIALS_PATCH_FAILURE',
};

export const patch = actions.patch(
  studentId => `${BASE_URL}/students/${studentId}/credentials/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
